import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@clerk/clerk-react'
import {useAPI} from "@/hooks/useAPI";

// TODO: aggregate all queries together
export const CURRENT_USER_QUERY_KEY = 'currentUser' as const

export interface GameGlassUser {
  id: number
  username: string
  email: string
  verified: boolean
  date_joined: string
  features: string[]
  packages: string[]
  is_staff: boolean
  is_shardsmith: boolean
  has_glasspass: boolean
  glasspass?: {
    type:string,
    expires_at?: string // ISO date string
  }
  email_domain: string
  accepts_marketing: boolean
  trial_eligible: boolean
  token: string
  intercom_jwt: string
  featurebase_jwt: string
}

export const useCurrentUser = () => {
  const { isSignedIn } = useAuth()
  const { getUserInfo } = useAPI()

  return useQuery<GameGlassUser | undefined>({
    queryKey: [CURRENT_USER_QUERY_KEY, isSignedIn],
    queryFn: async () => {
      return isSignedIn ? (await getUserInfo()).data : undefined
    },
    staleTime: Infinity,
    retry: 5
  })
}